import {
  Rocket, CheckCircle2, Music, Trophy, ListChecks, Layers, Flame, Crown, Award,
  Mic, CalendarCheck, Users, Megaphone, Briefcase, Sparkles,
} from "lucide-react";

export const BADGE_ICONS = {
  "rocket": Rocket,
  "check-circle": CheckCircle2,
  "music": Music,
  "trophy": Trophy,
  "list-checks": ListChecks,
  "layers": Layers,
  "flame": Flame,
  "crown": Crown,
  "mic": Mic,
  "calendar-check": CalendarCheck,
  "default": Award,
};

export const CATEGORY_META = {
  creation: { label: "Création", color: "#F59E0B", icon: Sparkles },
  contenu: { label: "Contenu", color: "#38BDF8", icon: Layers },
  audience: { label: "Audience", color: "#A78BFA", icon: Users },
  promotion: { label: "Promotion", color: "#F472B6", icon: Megaphone },
  business: { label: "Business", color: "#34D399", icon: Briefcase },
  live: { label: "Live", color: "#FB7185", icon: Mic },
};

export const PRIORITY_LABELS = {
  petite: { label: "Petite", xp: 10 },
  normale: { label: "Normale", xp: 20 },
  importante: { label: "Importante", xp: 30 },
  majeure: { label: "Majeure", xp: 50 },
};

export function priorityAccent(priority) {
  const p = (priority || "").toLowerCase();
  if (["majeure", "haute", "urgente"].includes(p)) return { color: "#FB7185", label: priority };
  if (["importante", "important", "moyenne"].includes(p)) return { color: "#F59E0B", label: priority };
  return { color: "#71717A", label: priority || "Normale" };
}

export const RISK_META = {
  low: { label: "Dans les temps", color: "#34D399", dot: "🟢" },
  medium: { label: "Risque de retard", color: "#F59E0B", dot: "🟠" },
  high: { label: "Retard probable", color: "#FB7185", dot: "🔴" },
};

export const STATUS_COLORS = {
  "À faire": "bg-zinc-700/50 text-zinc-300 border-zinc-600",
  "En cours": "bg-amber-500/15 text-amber-400 border-amber-500/40",
  "Terminée": "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
};

export const PROJECT_TYPE_META = {
  "Création": "🎨", "Contenu": "🎬", "Audience": "📈", "Promotion": "📣",
  "Business": "💼", "Événement": "🎤", "Collaboration": "🤝", "Autre": "✨",
  Single: "🎵", EP: "💿", Album: "📀", Clip: "🎬", Concert: "🎤", Promotion: "📣",
};

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}
